import { ExponantialBackOff } from './exponantialBackoff'
import {
  IExonantialBackOffOptions,
  getOptionsSanitized,
} from './interface/types'

export async function exponantialBackOff<T>(
  request: () => Promise<T>,
  options: Partial<IExonantialBackOffOptions> = {},
): Promise<T> {
  const sanitizedOptions = getOptionsSanitized(options)
  const backOff = new ExponantialBackOff(request, sanitizedOptions)

  return await backOff.execute()
}
